import { IColumnDataHandler } from '../../data-handlers/column/IColumnDataHandler'
import { Column } from '../../entities/column/Column'

export class ColumnRepository {
  handler: IColumnDataHandler

  constructor(handler: IColumnDataHandler) {
    this.handler = handler
  }

  getByDate(date: Date): Promise<Column[]> {
    return this.handler.queryByDate(date)
  }
}
